// @ts-ignore
import Config from 'Config';

export function pushCustomEvent(event: string): void {
  // Disable GTM events if not in production
  if (!window || Config.Environment.ENVIRONMENT_TYPE !== 'production') {
    console.log(`%c⚡️ GTMPUSH - ${event}`, 'color: #962857;font-weight:bold;');
    return;
  }

  try {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({ event });
  } catch (e) {
    console.error(`googleTagManager - failed to push event key=${event}`);
  }
}
